import React, { useState } from "react";
import { Calendar as CalIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Calendar } from "../ui/calendar";
import { Button } from "../ui/button";

const toISO = (d) => {
  if (!d) return "";
  const z = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  return z.toISOString().slice(0, 10);
};
const fromISO = (s) => {
  if (!s) return undefined;
  const d = new Date(String(s).slice(0, 10) + "T00:00:00");
  return Number.isNaN(d.getTime()) ? undefined : d;
};
export const formatDMY = (s) => {
  const d = fromISO(s);
  if (!d) return s || "";
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
};

// Tap-to-open calendar date picker. Displays DD/MM/YYYY, stores ISO (yyyy-mm-dd).
export function DateField({ value, onChange, placeholder = "DD/MM/YYYY", testId = "date-field", disabled, fromYear = 2000, toYear = 2040, disablePast = false }) {
  const [open, setOpen] = useState(false);
  const selected = fromISO(value);
  const today = new Date(); today.setHours(0, 0, 0, 0);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" disabled={disabled} className="h-10 w-full justify-start rounded-xl font-normal" data-testid={testId}>
          <CalIcon className="mr-2 h-4 w-4 text-ink-muted" />
          {value ? <span>{formatDMY(value)}</span> : <span className="text-ink-muted">{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={selected}
          onSelect={(d) => { onChange(toISO(d)); setOpen(false); }}
          defaultMonth={selected || today}
          captionLayout="dropdown-buttons"
          fromYear={fromYear}
          toYear={toYear}
          disabled={disablePast ? { before: today } : undefined}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
